var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "eui-panel",
    {
      class: {
        "-osynlig": _vm.skaVaraOsynlig
      },
      staticStyle: { width: "100%", height: "100%" },
      attrs: {
        "vp-huvud-text": "Okänd widget",
        "vp-inaktiverad": _vm.skaVaraInaktiverad,
        disabled: _vm.skaVaraInaktiverad,
        "vp-osynlig": _vm.skaVaraOsynlig,
        "vp-visa-menyfaltet": _vm.vpArIRedigeralage,
        "vp-meny-config": _vm.menyConfig
      },
      on: {
        "update:vpMenyConfig": function($event) {
          _vm.menyConfig = $event
        },
        "update:vp-meny-config": function($event) {
          _vm.menyConfig = $event
        },
        "menyalternativ-valt-i-panel": _vm.onMenyalternativValtIPanel
      }
    },
    [
      _c("div", [
        _c("p", { staticClass: "mellan ellipsis" }, [
          _vm._v("Widget id: " + _vm._s(_vm.vpWidgetId))
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "mellan styckemellanrum-inget ellipsis" }, [
          _vm._v("Element name: " + _vm._s(_vm.vpWidgetOriginalElementName))
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "mellan styckemellanrum-inget ellipsis" }, [
          _vm._v("Parameters: " + _vm._s(_vm.vpWidgetParameters))
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "mellan styckemellanrum-inget ellipsis" }, [
          _vm._v("Settings1: " + _vm._s(_vm.vpWidgetSettings))
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "mellan styckemellanrum-inget ellipsis" }, [
          _vm._v("Settings2: " + _vm._s(_vm.vpWidgetData.settings))
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "mellan styckemellanrum-inget ellipsis" }, [
          _vm._v("Exception: " + _vm._s(_vm.vpWidgetData.exception))
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }